import React, { useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import { UserSettingsDataProvider } from '../data/DataProviders/UserSettingsDataProvider';
import { AppDataProvider } from '../components/AppDataProvider';
import { ForgotPassword } from './forgot-password/ForgotPassword';
import { Registration } from './registration/Register';
import { ResetPassword } from './reset-password/ResetPassword';
import { Login } from './login/Login';

import { IdleTimerContainer } from '../components/IdleTimerContainer';
import UnsupportedBrowser from './unsupported-browser/UnsupportedBrowser';
import { isSupportedBrowser } from '../lib/browser-check';

import { Content } from './content';
import { OrganizationListProvider } from '../data/DataProviders/OrganizationListProvider';
import { UserRoleOperationProvider } from '../data/DataProviders/RoleOperationDataProvider';
import { DataProviderCache } from '../data/DataProviders/DataProviderCache';
import { OrganizationDataProvider } from '../data/DataProviders/OrganizationDataProvider';
import { SignalRConnectionProvider } from '../data/DataProviders/SignalRConnectionProvider';

const App: React.FC = () => {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, -100);
        }, 500);
    }, []);

    return (
        <div className="full">
            <Switch>
                <Route path={['/login', '/forgot-password', '/register', '/reset-password', '/unsupported-browser']}>
                    <Switch>
                        <Route exact path="/unsupported-browser" component={UnsupportedBrowser} />
                    </Switch>

                    {isSupportedBrowser() ? (
                        <Switch>
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/forgot-password" component={ForgotPassword} />
                            <Route exact path="/register/:code" component={Registration} />
                            <Route path="/reset-password/:code" component={ResetPassword} />
                            <Redirect to="/login" />
                        </Switch>
                    ) : (
                        <Redirect to="/unsupported-browser"></Redirect>
                    )}
                </Route>

                <PrivateRoute path="*">
                    <AppDataProvider>
                        <IdleTimerContainer />
                        <UserSettingsDataProvider />
                        <DataProviderCache for="User Role">
                            <UserRoleOperationProvider>
                                <OrganizationListProvider>
                                    <SignalRConnectionProvider>
                                        <OrganizationDataProvider>
                                            <Content />
                                        </OrganizationDataProvider>
                                    </SignalRConnectionProvider>
                                </OrganizationListProvider>
                            </UserRoleOperationProvider>
                        </DataProviderCache>
                    </AppDataProvider>
                </PrivateRoute>
            </Switch>
        </div>
    );
};

export default App;
